var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chips-list"},_vm._l((_vm.list),function(item,index){return _c('v-chip',{key:index,staticClass:"chips-list__chip",attrs:{"title":item,"small":""}},[_vm._v(_vm._s(item))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }